// extracted by mini-css-extract-plugin
module.exports = {"content":"commonTriageDetail_content__3dNzK","table":"commonTriageDetail_table__Owhbg","form":"commonTriageDetail_form__3Awgf","bar":"commonTriageDetail_bar__3AGmR"};